import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { FaqItem } from './FaqItem';
export const Faq = ({ blockTitle, items }) => {
    return (_jsxs(Box, { children: [_jsx(Box, { as: "h2", children: blockTitle }), items.map((item) => (_jsx(FaqItem, { item: item }, item.question)))] }));
};
